import React from 'react';

import ReactDOM from 'react-dom/client';
import { ConfigProvider, theme } from 'antd';
// import { PublicClientApplication } from "@azure/msal-browser";
// import { MsalProvider } from "@azure/msal-react";
// import { msalConfig } from "./components/authConfig";
import { AuthProvider } from "react-oidc-context";
import 'antd/dist/reset.css';
import App from './App';
import { cognitoAuthConfig, isAuthEnabled } from './components/authConfig';
import { ThemeProvider, useTheme } from './context/ThemeContext';

const OidcWrapper = ({ children }) =>
  isAuthEnabled ? (
    <AuthProvider {...cognitoAuthConfig}>{children}</AuthProvider>
  ) : (
    children
  );

const AppWithTheme = () => {
  const { isDark } = useTheme();

  return (
    <ConfigProvider
      theme={{
        algorithm: isDark ? theme.darkAlgorithm : theme.defaultAlgorithm,
        token: {
          colorPrimary: '#1890ff',
          colorBgContainer: isDark ? '#161b22' : '#ffffff',
          colorBgElevated: isDark ? '#1c2128' : '#ffffff',
          colorBgLayout: isDark ? '#0d1117' : '#f5f7fa',
          colorText: isDark ? '#e6edf3' : 'rgba(0, 0, 0, 0.88)',
          colorTextSecondary: isDark ? '#adbac7' : 'rgba(0, 0, 0, 0.65)',
          colorBorder: isDark ? '#30363d' : '#d9d9d9',
          colorBorderSecondary: isDark ? '#21262d' : '#f0f0f0',
          colorFillSecondary: isDark ? '#21262d' : '#fafafa',
          colorFillTertiary: isDark ? '#161b22' : '#f5f5f5',
        },
        components: {
          Select: {
            optionSelectedBg: isDark ? '#1c2128' : '#e6f7ff',
            optionActiveBg: isDark ? '#21262d' : '#f5f5f5',
            colorText: isDark ? '#e6edf3' : 'rgba(0, 0, 0, 0.88)',
            colorTextPlaceholder: isDark ? '#8b949e' : 'rgba(0, 0, 0, 0.25)',
            colorBgElevated: isDark ? '#1c2128' : '#ffffff',
            colorBgContainer: isDark ? '#161b22' : '#ffffff',
            colorBorder: isDark ? '#30363d' : '#d9d9d9',
            controlItemBgHover: isDark ? '#21262d' : '#f5f5f5',
            controlItemBgActive: isDark ? '#1c2128' : '#e6f7ff',
            controlItemBgActiveHover: isDark ? '#21262d' : '#bae7ff',
            multipleItemBg: isDark ? '#21262d' : '#f0f0f0',
            multipleItemBorderColor: isDark ? '#30363d' : '#d9d9d9',
            selectorBg: isDark ? '#161b22' : '#ffffff',
          },
          Menu: {
            itemSelectedBg: isDark ? '#1c2128' : '#e6f7ff',
            itemSelectedColor: isDark ? '#1890ff' : '#1890ff',
            itemHoverBg: isDark ? '#21262d' : '#f5f5f5',
            itemHoverColor: isDark ? '#e6edf3' : 'rgba(0, 0, 0, 0.88)',
            itemColor: isDark ? '#adbac7' : 'rgba(0, 0, 0, 0.88)',
            subMenuItemBg: isDark ? '#161b22' : '#ffffff',
          },
        },
      }}
    >
      <OidcWrapper>
        <App />
      </OidcWrapper>
    </ConfigProvider>
  );
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ThemeProvider>
      <AppWithTheme />
    </ThemeProvider>
  </React.StrictMode>
);
